import { gql } from '@apollo/client'

export const PostInformationPublicFragment = gql`
  fragment PostInformationPublic on Post {
    _id
    categoryId
    comments
    creatorId
    description
    durationInSeconds
    engagement
    engagementRatio
    engagementVariation
    likes
    postId
    postType
    postUrl
    provider
    publishedAt
    reactionsTotal
    shares
    tags
    thumbnail
    title
    videoUrl
    views
    viewsVariation
    isPublicity
    productType
    hasViewsReaction
    isViewsReactionDisabled
    hasLikesReaction
    isLikesReactionDisabled
    hasCommentsReaction
    isCommentsReactionDisabled
    creator {
      ... on Creator {
        _id
        groupId
        thumbnail
        title
        creatorId
      }
      ... on CreatorIncompleteIN {
        title
      }
      ... on CreatorIncompleteTT {
        title
      }
      ... on CreatorIncompleteYT {
        title
      }
      ... on CreatorIncompleteFB {
        title
      }
      ... on CreatorIncompleteTW {
        title
      }
      ... on CreatorPublic {
        title
        _id
        thumbnail
        groupId
      }
    }

    live {
      endTime
      scheduledTime
      startTime
      state

      performance {
        time
        concurrentViewers
        likes
      }
    }
  }
`

export const PostInformationFragment = gql`
  fragment PostInformationFull on Post {
    ...PostInformationPublic

    territories {
      name
      territoryId
    }
  }
  ${PostInformationPublicFragment}
`
